import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  HEADER_FILL,
  TABLE_HEADER_FILL,
  formatNumber,
  mergeRow,
  safeText,
  setCell,
} from "./principle6SheetHelpers";
import { filterPopulatedRows, setStandardDetailWidths } from "./principle8SheetHelpers";

const TITLE_ROW = 3;
const HEADER_ROW = 4;
const DATA_START_ROW = 5;

export const SHEET_NAME = "CSR in aspirational districts";

const SHEET_TITLE =
  "Provide the following information on CSR projects undertaken by your entity in designated aspirational districts as identified by government bodies";

export function buildCsrInAspirationalDistrictsSheet(workbook, sectionC) {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: true }] });
  setStandardDetailWidths(ws, { D: 8, E: 16, F: 24, G: 18 });

  const rows = filterPopulatedRows(
    sectionC?.principle8?.leadershipIndicator?.csrProjectsInAspirationalDistricts,
    ["state", "aspirationalDistrict", "amountSpent"]
  );

  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_8, { mergeEnd: COL_G });

  mergeRow(ws, TITLE_ROW, COL_D, COL_G, SHEET_TITLE, {
    bold: true,
    fill: HEADER_FILL,
    align: "center",
  });

  setCell(ws, HEADER_ROW, COL_D, "Sr.No.", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_E, "State", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_F, "Aspirational District", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_G, "Amount spent (In INR)", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });

  rows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    setCell(ws, row, COL_D, String(idx + 1), { align: "center" });
    setCell(ws, row, COL_E, safeText(item?.state), { align: "left" });
    setCell(ws, row, COL_F, safeText(item?.aspirationalDistrict), { align: "left" });
    setCell(ws, row, COL_G, formatNumber(item?.amountSpent), { align: "center" });
  });

  return ws;
}
